 
                        <nb-card  *ngIf="stream" [nbSpinner]="loading" class="own-scroll">
                            <nb-card-header>
				<div style="display:flex">
                              <div  style="display:flex;   cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">Режим "Розблокувати по QR"</div>  
<div  style="display:flex; margin-left:auto; cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">
	
				   <nb-toggle  
					 
				     labelPosition="left"
				      [(checked)]="qrOn" 
				      (checkedChange)="toggleQrOn()" 
				      status="primary">
				      <span *ngIf="qrOn">Увімкнено</span>
				      <span *ngIf="!qrOn">Вимкнено</span>
				    </nb-toggle>

   </div>
				</div>
                            </nb-card-header>
                           
                            
                            </nb-card>
 
  


 
